/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Advanced_AiInputs */

const en_pricing_feature_advanced_ai = /** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advanced AI Intelligence`)
};

const es_pricing_feature_advanced_ai = /** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia de IA Avanzada`)
};

const fr_pricing_feature_advanced_ai = /** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence IA avancée`)
};

const de_pricing_feature_advanced_ai = /** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterte KI-Intelligenz`)
};

const id_pricing_feature_advanced_ai = /** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecerdasan AI Lanjutan`)
};

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const ja_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const zh_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const ar_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const it_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const ru_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const pt_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/** @type {(inputs: Pricing_Feature_Advanced_AiInputs) => LocalizedString} */
const ko_pricing_feature_advanced_ai = en_pricing_feature_advanced_ai;

/**
* | output |
* | --- |
* | "Advanced AI Intelligence" |
*
* @param {Pricing_Feature_Advanced_AiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_advanced_ai = /** @type {((inputs?: Pricing_Feature_Advanced_AiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Advanced_AiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_advanced_ai(inputs)
	if (locale === "es") return es_pricing_feature_advanced_ai(inputs)
	if (locale === "fr") return fr_pricing_feature_advanced_ai(inputs)
	if (locale === "de") return de_pricing_feature_advanced_ai(inputs)
	if (locale === "ja") return ja_pricing_feature_advanced_ai(inputs)
	if (locale === "zh") return zh_pricing_feature_advanced_ai(inputs)
	if (locale === "ar") return ar_pricing_feature_advanced_ai(inputs)
	if (locale === "id") return id_pricing_feature_advanced_ai(inputs)
	if (locale === "it") return it_pricing_feature_advanced_ai(inputs)
	if (locale === "ru") return ru_pricing_feature_advanced_ai(inputs)
	if (locale === "pt") return pt_pricing_feature_advanced_ai(inputs)
	return ko_pricing_feature_advanced_ai(inputs)
});